import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../shared/store/common/component-store-v2.factory';
import { ActivatedRoute } from '@angular/router';
import { TreeNode } from '@openng/optimus-ui/api';
import { router } from '../../../shared/shared.global-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { currentUserId } from '../../../../store/current-user-id';
import { getBreadcrumbMenusFrag } from './breadcrumb.query';

@Injectable()
export class BreadcrumbStore extends ComponentStoreV2Factory {

    private readonly route = inject(ActivatedRoute);

    private readonly navigationEnd = toSignal(router.events);

    public breadcrumbMenus = computed(() => {
        // Fucking read-only
        return signal((this.data.getBreadcrumbMenus() || []).map((it) => ({ ...it })));
    });

    public currentRawUrl = computed(() => {
        this.navigationEnd();
        const frags = this.route.snapshot.root.firstChild?.pathFromRoot;
        if (!frags) return;

        let paths = [];
        let node: TreeNode | any = (frags[frags.length - 1] as any)?._routerState?._root;

        while (node) {
            paths.push(node?.value?.routeConfig?.path);
            node = node?.children?.[0];
        }

        return paths.filter((it) => it).join('/');
    });

    public breadcrumbMenuContexts = computed(() => {
        this.navigationEnd();
        let child = this.route.firstChild;
        const contexts = new Set<string>();

        while (child) {
            const data = child.snapshot.data;
            if ('breadcrumbMenuContext' in data) {
                contexts.add(data.breadcrumbMenuContext);
            }
            child = child.firstChild;
        }

        return contexts;
    });

    public currentMenuOptions = computed(() => {
        const url = this.currentRawUrl();

        return this.breadcrumbMenus()()?.find((it) => it.url == url)?.options || [];
    });

    constructor() {
        super();

        effect(() => {
            const userId = currentUserId();
            if (!userId) return;

            this.api.getBreadcrumbMenus(null, getBreadcrumbMenusFrag);
        });
    }

}
